import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomerListComponent } from "./customer-list/customer-list.component";
import { CustomerDetailComponent } from "./customer-detail/customer-detail.component";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const customersRoutes: Routes = [
  {
    path: "",
    component: CustomerListComponent,
  },
  { path: "reset", redirectTo: "customer", pathMatch: "prefix" },
  {
    path: "customer",
    component: CustomerDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "customer/:id",
    component: CustomerDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(customersRoutes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule {}
